import { useContext, useState, useEffect } from 'react';
import { CompareSettings } from './CompareSettings';
import Container from '@/components/layout/Container';

export default function CompareTags({ block, entryUid, onDesktop, position }) {
  const compareSettings = useContext(CompareSettings);
  const { compare_tags } = block;

  const [visibleTags, setVisibleTags] = useState([]);

  useEffect(() => {
    const tempArr = [];
    if (onDesktop) {
      compareSettings.desktopSelectors.forEach((selected) => {
        const matchingProduct = compare_tags.products[selected.index];
        tempArr.push(matchingProduct);
      });
    } else {
      compareSettings.mobileSelectors.forEach((selected) => {
        const matchingProduct = compare_tags.products[selected.index];
        tempArr.push(matchingProduct);
      });
    }
    setVisibleTags(tempArr);
  }, [compareSettings, onDesktop, compare_tags]);

  return (
    <section
      id={entryUid + '_' + position}
      data-name="compare-products-cards"
      className="pt-[24px] pb-[24px] lg:pt-[34px] lg:pb-[34px]"
    >
      <Container fullPage={false}>
        <div
          className={`${onDesktop ? 'preheading-r' : 'preheading-s'} pb-2 pl-3`}
        >
          {compare_tags.row_title}
        </div>
        <div className="grid grid-cols-2 gap-x-[16px] sm:gap-x-[24px] lg:grid-cols-3 lg:gap-x-[32px]">
          {visibleTags.map((product, index) => {
            return (
              <div
                key={index}
                className="border-dawn-grey-80 w-full border-t-2"
              >
                <div className="mt-5 flex flex-wrap lg:mt-10">
                  {product.product_tags.map((tag, index) => {
                    return (
                      <div
                        key={index}
                        className={`text-[${tag.text_color}] bg-[${tag.background_color}] best-for-tag-r mr-2 mb-2 max-h-7 px-2 py-[3px]`}
                      >
                        {tag.tag_copy}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
